function textValue(value) {
  return value === null || value === undefined ? '' : String(value)
}

export const rawText = {
  bind(element, binding) {
    element.textContent = textValue(binding.value)
  },
  update(element, binding) {
    if (binding.value !== binding.oldValue) element.textContent = textValue(binding.value)
  }
}

export const rawHtml = {
  bind(element, binding) {
    element.innerHTML = textValue(binding.value)
  },
  update(element, binding) {
    if (binding.value !== binding.oldValue) element.innerHTML = textValue(binding.value)
  }
}
